export default __webpack_public_path__ + "static/media/wedding-thumbnail-6.bac31c6c.jpg";